module.exports = __webpack_public_path__ + "img/画板 1 拷贝 21.a71ba992.jpg";